import { INVOICE_STATUS } from "../constants/invoices";

export const getInvoiceStatus = (status) =>
  INVOICE_STATUS.reduce((acc, curr) => {
    if (acc) {
      return acc;
    }

    if (curr.value === status) {
      return curr;
    }

    return null;
  }, null);
